import type { ICmsPlatform } from "@mw/shared/payload-types";

import img1x1Core1 from "@ui/assets/placeholders/new/1x1/core-1.jpg";
import img1x1Core2 from "@ui/assets/placeholders/new/1x1/core-2.jpg";
import img1x1Core3 from "@ui/assets/placeholders/new/1x1/core-3.jpg";
import img1x1Core4 from "@ui/assets/placeholders/new/1x1/core-4.jpg";
import img1x1Core5 from "@ui/assets/placeholders/new/1x1/core-5.jpg";

import img1x1Creative1 from "@ui/assets/placeholders/new/1x1/creative-1.jpg";
import img1x1Creative2 from "@ui/assets/placeholders/new/1x1/creative-2.jpg";
import img1x1Creative3 from "@ui/assets/placeholders/new/1x1/creative-3.jpg";

import img1x1Agents1 from "@ui/assets/placeholders/new/1x1/agents-1.jpg";
import img1x1Agents2 from "@ui/assets/placeholders/new/1x1/agents-2.jpg";
import img1x1Agents3 from "@ui/assets/placeholders/new/1x1/agents-3.jpg";

import img1x1Api1 from "@ui/assets/placeholders/new/1x1/api-1.png";
import img1x1Api2 from "@ui/assets/placeholders/new/1x1/api-2.png";

import img16x9Core1 from "@ui/assets/placeholders/new/16x9/core-1.jpg";
import img16x9Core2 from "@ui/assets/placeholders/new/16x9/core-2.jpg";
import img16x9Core3 from "@ui/assets/placeholders/new/16x9/core-3.jpg";
import img16x9Core4 from "@ui/assets/placeholders/new/16x9/core-4.jpg";
import img16x9Core5 from "@ui/assets/placeholders/new/16x9/core-5.jpg";

import img16x9Creative1 from "@ui/assets/placeholders/new/16x9/creative-1.jpg";
import img16x9Creative2 from "@ui/assets/placeholders/new/16x9/creative-2.jpg";
import img16x9Creative3 from "@ui/assets/placeholders/new/16x9/creative-3.jpg";

import img16x9Agents1 from "@ui/assets/placeholders/new/16x9/agents-1.jpg";
import img16x9Agents2 from "@ui/assets/placeholders/new/16x9/agents-2.jpg";
import img16x9Agents3 from "@ui/assets/placeholders/new/16x9/agents-3.jpg";

import img16x9Api1 from "@ui/assets/placeholders/new/16x9/api-1.png";
import img16x9Api2 from "@ui/assets/placeholders/new/16x9/api-2.png";

const images = {
  default: {
    "1x1": [img1x1Core1, img1x1Core2, img1x1Core3, img1x1Core4, img1x1Core5],
    "16x9": [img16x9Core1, img16x9Core2, img16x9Core3, img16x9Core4, img16x9Core5],
  },
  creative: {
    "1x1": [img1x1Creative1, img1x1Creative2, img1x1Creative3],
    "16x9": [img16x9Creative1, img16x9Creative2, img16x9Creative3],
  },
  agents: {
    "1x1": [img1x1Agents1, img1x1Agents2, img1x1Agents3],
    "16x9": [img16x9Agents1, img16x9Agents2, img16x9Agents3],
  },
  api: {
    "1x1": [img1x1Api1, img1x1Api2],
    "16x9": [img16x9Api1, img16x9Api2],
  },
};

function hashString(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0; // 32-bit int
  }
  return Math.abs(hash);
}

export type PlaceholderRatio = "1x1" | "16x9";

export function getImagePlaceholder({
  ratio = "1x1",
  platform = "default",
  key,
}: { ratio?: PlaceholderRatio; platform?: ICmsPlatform; key?: string } = {}) {
  const resolvedPlatform = platform && platform in images ? (platform as keyof typeof images) : "default";

  const platformImages = images[resolvedPlatform][ratio];

  if (typeof key === "string") {
    const hash = hashString(key);
    return platformImages[hash % platformImages.length];
  }

  return platformImages[0];
}
